import { GATEWAY_USER_SETTINGS_STORAGE_KEY } from './const/gatewayUserSettingsStorageKey.const'
import type { GatewayUserSettings } from './interfaces/gatewayUserSettings.interface'

export function saveGatewayUserSettings(settings: GatewayUserSettings): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.setItem(GATEWAY_USER_SETTINGS_STORAGE_KEY, JSON.stringify(settings))
  } catch {
    // localStorage unavailable (incognito, quota exceeded)
  }
}
